export default __webpack_public_path__ + "static/media/HomeOwnerImage3.e4ca71ae.jpg";